"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);

    this.estoreLocation = null;
    this.siteLocation = null;
    this.nameCookiesInternal = [];
  }

  _createClass(_class, [{
    key: "nameCookies",
    get: function get() {
      return this.nameCookiesInternal;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      if (this.cartUrlInternal) {
        return this.cartUrlInternal;
      }

      return this.estoreLocation + "/cart";
    },
    set: function set(value) {
      this.cartUrlInternal = value;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      if (this.loginUrlInternal) {
        return this.loginUrlInternal;
      }

      return this.siteLocation + "/your-accounts/";
    },
    set: function set(value) {
      this.loginUrlInternal = value;
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      if (this.accountOverviewUrlInternal) {
        return this.accountOverviewUrlInternal;
      }

      return this.siteLocation + "/your-accounts/";
    },
    set: function set(value) {
      this.accountOverviewUrlInternal = value;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      if (this.logoutUrlInternal) {
        return this.logoutUrlInternal;
      }

      return this.siteLocation + "/your-accounts/?signout=true";
    },
    set: function set(value) {
      this.logoutUrlInternal = value;
    }
  }]);

  return _class;
}();

exports.default = _class;